export default __webpack_public_path__ + "static/media/kimquy.574d0ccd.png";